import React, { useEffect } from 'react'
import useTranslation from '../../shared/TranslationProvider'
import { useExercise } from '../ExerciseProvider'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../../lib/ui/select'

const PartFour = () => {
  const {
    exerciseIndex,
    trackContent,
    updateDecisionMakingExerciseResponse,
    getDecisionMakingExerciseResponse,
  } = useExercise()
  const { t } = useTranslation(
    `decision_making.pages.${exerciseIndex}.score-career-options`,
  )
  const values = Object.keys(trackContent['value_importance'])
  const jobs = trackContent['positions']

  useEffect(() => {
    let scoredOptions = new Array(8 * jobs.length)
    values.map((value, idx) => {
      for (let i = 0; i < jobs.length; i++) {
        scoredOptions[idx * jobs.length + i] = {
          score:
            getDecisionMakingExerciseResponse('scored_options')?.[
              idx * jobs.length + 1
            ]?.score || 3,
          value: value,
          importance: trackContent['value_importance'][value],
          position: jobs[i],
        }
      }
    })
    updateDecisionMakingExerciseResponse('scored_options', scoredOptions)
  }, [])

  const updateScoredOptions = (score, index) => {
    let scoredOptions =
      getDecisionMakingExerciseResponse('scored_options') || new Array(24)
    let careerScore = scoredOptions[index]
    scoredOptions[index] = {
      ...careerScore,
      score: score,
    }
    updateDecisionMakingExerciseResponse('scored_options', scoredOptions)
  }

  const getImportance = (value) => {
    if (value === 3) {
      return t('critical')
    } else if (value === 2) {
      return t('important')
    } else {
      return t('less_important')
    }
  }

  return (
    <>
      <h1>{t('title')}</h1>
      <p className="pb-4">{t('p1')}</p>
      <div className="questions flex flex-col">
        <table className="score-options">
          <thead>
            <tr>
              <th>{t('value')}</th>
              {jobs.map((job, idx) => {
                return <th key={idx}>{job}</th>
              })}
            </tr>
          </thead>
          <tbody>
            {values.map((value, index) => {
              const newIndex = index
              return (
                <tr key={value + index} className="h-16">
                  <td>
                    {value} (
                    {getImportance(trackContent['value_importance'][value])})
                  </td>
                  {jobs.map((job, i) => {
                    const scoredOptions =
                      getDecisionMakingExerciseResponse('scored_options')
                    return (
                      <td key={value + job + i}>
                        <Select
                          onValueChange={(e) =>
                            updateScoredOptions(e, newIndex * jobs.length + i)
                          }
                          value={
                            scoredOptions?.[newIndex * jobs.length + i]?.[
                              'score'
                            ]
                              ? scoredOptions[newIndex * jobs.length + i][
                                  'score'
                                ]
                              : ''
                          }
                          className="w-full rounded-[20px] border border-[#D3D3D3] bg-[#F7FAFC] p-3 font-roboto text-base"
                        >
                          <SelectTrigger className="sm:w-4/6">
                            <SelectValue placeholder="Select an option" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem key={'exceeds'} value={3}>
                              {t('exceeds')}
                            </SelectItem>
                            <SelectItem key={'meets'} value={2}>
                              {t('meets')}
                            </SelectItem>
                            <SelectItem key={'short'} value={1}>
                              {t('short')}
                            </SelectItem>
                          </SelectContent>
                        </Select>
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default PartFour
